import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7266e2d6 = () => interopDefault(import('../../../pages/400/index.vue' /* webpackChunkName: "pages/400/index" */))
const _f50ab250 = () => interopDefault(import('../../../pages/403/index.vue' /* webpackChunkName: "pages/403/index" */))
const _1a5f5999 = () => interopDefault(import('../../../pages/404/index.vue' /* webpackChunkName: "pages/404/index" */))
const _0b73d42e = () => interopDefault(import('../../../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _7e93dd86 = () => interopDefault(import('../../../pages/ai/index.vue' /* webpackChunkName: "pages/ai/index" */))
const _cc131b74 = () => interopDefault(import('../../../pages/archives/index.vue' /* webpackChunkName: "pages/archives/index" */))
const _f14c1f38 = () => interopDefault(import('../../../pages/cases/index.vue' /* webpackChunkName: "pages/cases/index" */))
const _77ebc0fe = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _03a984b0 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _612c1cf8 = () => interopDefault(import('../../../pages/offline/index.vue' /* webpackChunkName: "pages/offline/index" */))
const _0df2a26c = () => interopDefault(import('../../../pages/privacy-policy/index.vue' /* webpackChunkName: "pages/privacy-policy/index" */))
const _556d49a8 = () => interopDefault(import('../../../pages/terms/index.vue' /* webpackChunkName: "pages/terms/index" */))
const _52ee7d69 = () => interopDefault(import('../../../pages/ai/utils/chatBotMethods.js' /* webpackChunkName: "pages/ai/utils/chatBotMethods" */))
const _68a7109f = () => interopDefault(import('../../../pages/cases/_slug/index.vue' /* webpackChunkName: "pages/cases/_slug/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/400",
    component: _7266e2d6,
    name: "400___en"
  }, {
    path: "/403",
    component: _f50ab250,
    name: "403___en"
  }, {
    path: "/404",
    component: _1a5f5999,
    name: "404___en"
  }, {
    path: "/about",
    component: _0b73d42e,
    name: "about___en"
  }, {
    path: "/ai",
    component: _7e93dd86,
    name: "ai___en"
  }, {
    path: "/archives",
    component: _cc131b74,
    name: "archives___en"
  }, {
    path: "/cases",
    component: _f14c1f38,
    name: "cases___en"
  }, {
    path: "/contact",
    component: _77ebc0fe,
    name: "contact___en"
  }, {
    path: "/ja",
    component: _03a984b0,
    name: "index___ja"
  }, {
    path: "/offline",
    component: _612c1cf8,
    name: "offline___en"
  }, {
    path: "/privacy-policy",
    component: _0df2a26c,
    name: "privacy-policy___en"
  }, {
    path: "/terms",
    component: _556d49a8,
    name: "terms___en"
  }, {
    path: "/ja/400",
    component: _7266e2d6,
    name: "400___ja"
  }, {
    path: "/ja/403",
    component: _f50ab250,
    name: "403___ja"
  }, {
    path: "/ja/404",
    component: _1a5f5999,
    name: "404___ja"
  }, {
    path: "/ja/about",
    component: _0b73d42e,
    name: "about___ja"
  }, {
    path: "/ja/ai",
    component: _7e93dd86,
    name: "ai___ja"
  }, {
    path: "/ja/archives",
    component: _cc131b74,
    name: "archives___ja"
  }, {
    path: "/ja/cases",
    component: _f14c1f38,
    name: "cases___ja"
  }, {
    path: "/ja/contact",
    component: _77ebc0fe,
    name: "contact___ja"
  }, {
    path: "/ja/offline",
    component: _612c1cf8,
    name: "offline___ja"
  }, {
    path: "/ja/privacy-policy",
    component: _0df2a26c,
    name: "privacy-policy___ja"
  }, {
    path: "/ja/terms",
    component: _556d49a8,
    name: "terms___ja"
  }, {
    path: "/ai/utils/chatBotMethods",
    component: _52ee7d69,
    name: "ai-utils-chatBotMethods___en"
  }, {
    path: "/ja/ai/utils/chatBotMethods",
    component: _52ee7d69,
    name: "ai-utils-chatBotMethods___ja"
  }, {
    path: "/",
    component: _03a984b0,
    name: "index___en"
  }, {
    path: "/ja/cases/:slug",
    component: _68a7109f,
    name: "cases-slug___ja"
  }, {
    path: "/ja/ja/*",
    component: _1a5f5999,
    name: "404ja___ja"
  }, {
    path: "/cases/:slug",
    component: _68a7109f,
    name: "cases-slug___en"
  }, {
    path: "/ja/*",
    component: _1a5f5999,
    name: "404en___ja"
  }, {
    path: "/ja/*",
    component: _1a5f5999,
    name: "404ja___en"
  }, {
    path: "/*",
    component: _1a5f5999,
    name: "404en___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
